import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import SVGImage from '~/components/Image/SVGImage'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import useBootcampProductCardStats from '~/statistics/hooks/useBootcampProductCardStats'
import { AppLanguage } from '~/types/locale'
import { BootcampProductAPIStat } from '~/redux/apis/user-stats-api'
import StripeProgressBar from '~/bootcamp/components/StripeProgressBar/StripeProgressBar'
import { getColorClassnameFromId } from '~/statistics/utils/common.utils'

import TimeStat from '../../ProfileCards/TimeStat'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  product: BootcampProductAPIStat
}

export default function Summary({ showContent, onClick, product }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const {
    subjectTitle,
    videoCourseName,
    timeSpent: { days, hours, minutes },
    correctAnswerPercentage,
    progressBarPercentage,
    supportsCurrentLocale,
  } = useBootcampProductCardStats(product)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: videoCourseName })
  }

  const titleColorClassname = getColorClassnameFromId(product.id)

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={videoCourseName}
        hrefLocale={supportsCurrentLocale ? undefined : AppLanguage.EN}
        iconAltText={t('alt_texts.vcc')}
        iconSrcKey="icons/products/videocrashcourse.png"
        onClickTitle={onClickTitle}
        productSubtitle={subjectTitle}
        productTitle={t('video-course')}
        showContent={showContent}
        titleClassname={`text-${titleColorClassname}`}
      />
      <div className="font-medium flex justify-between">
        <div className="flex items-center">
          <SVGImage alt={t('alt_texts.clock')} className="mr-2" height={20} srcKey="scoreboard/clock.svg" width={20} />
          <TimeStat days={days} hours={hours} minutes={minutes} />
        </div>
        <p>
          {t('correct-answer')} {correctAnswerPercentage}%
        </p>
      </div>
      <StripeProgressBar percentage={progressBarPercentage} progressColorClass={`bg-${titleColorClassname}`} />
    </button>
  )
}
